import { HD_URL, DEFAULT_ALTERNATE_LINKS } from '../../constants';

/* --- Schema & Meta Tag Helpers --- */

export const buildSearchSchema = () => ({
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  url: HD_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${HD_URL}/s/{search_term_string}?NCNI-5&gsitesearch`,
    'query-input': 'required name=search_term_string'
  }
});

export const buildOrganizationSchema = () => ({
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'The Home Depot',
  alternateName: 'Home Depot',
  url: HD_URL,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '1-800-466-3337',
    contactType: 'customer service'
  },
  sameAs: [
    'https://www.facebook.com/homedepot/',
    'https://twitter.com/HomeDepot',
    'https://www.instagram.com/homedepot/',
    'https://www.youtube.com/homedepot',
    'https://www.linkedin.com/company/the-home-depot',
    'https://www.pinterest.com/homedepot/'
  ]
});

export const buildPreloadImages = (preloadedImages = []) => preloadedImages.map(
  ({ preloadedImageUrl, preloadedImageId, media, fetchpriority } = {}) => ({
    rel: 'preload',
    as: 'image',
    href: preloadedImageUrl,
    id: preloadedImageId,
    media,
    fetchpriority: fetchpriority || 'high'
  })
);

export const buildAlternateLinks = (alternate) => {
  const links = (alternate && alternate.length ? alternate : DEFAULT_ALTERNATE_LINKS)
    .map(({ href, hreflang }) => {
      if (!href) return null;
      return {
        href,
        hreflang,
        id: `thd-helmet__link--${href}`
      };
    })
    .filter(Boolean);

  // Always add Android app link
  links.push({
    href: 'android-app://com.thehomedepot/homedepot/view/homepage',
    id: 'thd-helmet__link--android-app://com.thehomedepot/homedepot/view/homepage'
  });

  return links;
};
